export default __webpack_public_path__ + "static/project-slide-3-4032-2268-b9d5fec7ae137f2f5781c0602f0e7a14.webp";